// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class ActivitySummary {
  readonly id: string;
  readonly name: string;
  readonly description: string | null;
  readonly category: Enums.ActivityCategory;
  readonly status: Enums.ActivityStatus;
  readonly startTime: string;
  readonly endTime: string;
  readonly creator: string;
  readonly projectId: string | null;
  readonly marketId: string | null;
  readonly divisionId: string | null;
  readonly creatorId: string;
  readonly plantId: string | null;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.description = data.description === undefined ? null : data.description;
    this.category = data.category === undefined ? Enums.ActivityCategory.Task : data.category;
    this.status = data.status === undefined ? Enums.ActivityStatus.Planned : data.status;
    this.startTime = data.startTime === undefined ? '' : data.startTime;
    this.endTime = data.endTime === undefined ? '' : data.endTime;
    this.creator = data.creator === undefined ? '' : data.creator;
    this.projectId = data.projectId === undefined ? null : data.projectId;
    this.marketId = data.marketId === undefined ? null : data.marketId;
    this.divisionId = data.divisionId === undefined ? null : data.divisionId;
    this.creatorId = data.creatorId === undefined ? '' : data.creatorId;
    this.plantId = data.plantId === undefined ? null : data.plantId;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): ActivitySummary {
    const zeroValues: ExcludeMethodsDeep<ActivitySummary> = {
      id: NIL_UUID,
      name: '',
      description: null,
      category: Enums.ActivityCategory.Task,
      status: Enums.ActivityStatus.Planned,
      startTime: '',
      endTime: '',
      creator: '',
      projectId: null,
      marketId: null,
      divisionId: null,
      creatorId: '',
      plantId: null,
      isArchived: false,
    };
    return new ActivitySummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ActivitySummaryWireFormat = {
  id: string;
  name: string;
  description: string | null;
  category: string;
  status: string;
  startTime: string;
  endTime: string;
  creator: string;
  projectId: string | null;
  marketId: string | null;
  divisionId: string | null;
  creatorId: string;
  plantId: string | null;
  isArchived: boolean;
};

type NewActivitySummaryProps = PartialDeep<ActivitySummary, { recurseIntoArrays: true }>;
export const NewActivitySummary: (props: NewActivitySummaryProps) => ActivitySummary = (props) =>
  new ActivitySummary(props);

type NewActivitySummaryFromWireFormatProps = PartialDeep<
  ActivitySummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewActivitySummaryFromWireFormat: (
  props: NewActivitySummaryFromWireFormatProps,
) => ActivitySummary = (props) => new ActivitySummary(props);
